import {SECTIONS} from '../../constants';
import {FhsStepName} from '../../types';

export const computeActiveStep = (stepName: FhsStepName): number => {
  if (stepName === 'summary') return SECTIONS.length;

  // First step shows no progress yet so the first circle stays "upcoming"
  // until the user advances — that lets the fill transition play visibly.
  if (stepName === 'name') return -1;

  return Math.max(
    0,
    SECTIONS.findIndex((section) => section.stepNames.includes(stepName)),
  );
};
